import styled from '@emotion/styled';
import { casinoColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';

export const GameEditFormWrapper = styled('div', { label: 'GameEditFormWrapper' })`
    position: relative;
`;

interface BlurleyWrapperType {
    isBlur: boolean;
}

export const BlurleyWrapper = styled('div', { label: 'BlurleyWrapper' })<BlurleyWrapperType>`
    ${({ isBlur }): string => isBlur ? 'filter: blur(5px)' : ''};
`;

export const SwitcherWrapper = styled('div', { label: 'SwitcherWrapper' })`
    margin: 16px 0;
`;

export const UploadWrapper = styled('div', { label: 'UploadWrapper' })`
    margin-bottom: 16px;
`;

export const FormElements = styled('div', { label: 'FormElements' })`
    display: flex;
    flex-direction: column;
    width: 800px;
    padding: 0 50px;
    margin: 24px auto 20px auto;
`;

export const ActionsWrapper = styled('div', { label: 'ActionsWrapper' })`
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid ${casinoColors.veryLightPink};
    border-bottom: 1px solid ${casinoColors.veryLightPink};
`;

export const Left = styled('div', { label: 'Left' })`
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-left: 20px;
`;

export const Right = styled('div', { label: 'Right' })`
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-right: 20px;
`;

export const StatusSelect = styled('select', { label: 'StatusSelect' })`
    font-size: 18px;
    height: 40px;
    box-sizing: border-box;
    padding: 0 10px;
    margin-right: 10px;
    border: solid 1px ${casinoColors.veryLightPink};
    background-color: ${casinoColors.white};
`;

export const Button = styled('button', { label: 'Button' })`
    color: ${casinoColors.white};
    display: inline-block;
    border-radius: 3px;
    border: 1px solid ${casinoColors.black};
    background: ${casinoColors.black};
    font-weight: ${fontWeight.bold};
    padding: 9px 15px;
    font-size: 15px;
    line-height: 15px;
    margin: 0 5px 0 0;
    text-decoration: none;
    outline: none;
    cursor: pointer;
`;
